import io from "socket.io-client";
import React, { useEffect } from "react";

import { SOCKET_URL } from "../../Constants/AppConstants";

const Health = () => {
  useEffect(() => {
    const Socket = io(SOCKET_URL, {});
    Socket.emit("health", "LC is Healthy");
  }, []);

  return <h1 id="health">LC is Healthy</h1>;
};

export default Health;
